import React from "react";

const STYLES = {
  primary: "bg-orange-600 text-white hover:bg-orange-700",
  secondary: "bg-white border hover:bg-gray-50",
  subtle: "bg-gray-100 text-gray-800 hover:bg-gray-200",
  danger: "bg-red-600 text-white hover:bg-red-700",
  link: "text-blue-600 hover:underline bg-transparent border-0",
};

export default function Button({
  children,
  variant = "secondary",
  className = "",
  disabled,
  ...rest
}) {
  const base = "inline-flex items-center gap-1 px-3 py-2 rounded text-sm transition-colors border";
  const style = STYLES[variant] || STYLES.secondary;
  const disabledCls = disabled ? "opacity-50 cursor-not-allowed" : "";
  // if link, remove border spacing
  const useBase = variant === "link" ? "inline-flex items-center gap-1 text-sm" : base;
  return (
    <button className={`${useBase} ${style} ${disabledCls} ${className}`} disabled={disabled} {...rest}>
      {children}
    </button>
  );
}

